// extracted by mini-css-extract-plugin
module.exports =  {"factoid-item":"_32bbee5fda--factoid-item--ABc2c"};